import Vue from 'vue';
import { transformDna } from '../util/transformDna';

export default {

    // ****
    // ****
    getToken (state) {
        return state.token;
    },

    getTokens (state) {
        return state.tokens.sort(
            function (a, b) {
                if(a.owner.toLowerCase() > b.owner.toLowerCase()) return -1;
                if(a.owner.toLowerCase() < b.owner.toLowerCase()) return 1;
                return 0;
            });
    },

    getContractTokens (state) {
        return state.contractTokens;
    },

    getRegisteredTokens (state) {
        return state.registeredTokens;
    },

    getContract (state) {
        return state.contract;
    },

    getContractDetails (state) {
        return state.contractDetails;
    },

    // ---- CLEAN UP

    // *****
    // Cards

    getCard (state) {
        return state.card;
    },

    getCards (state) {
        return state.cards;
    },

    getAllCards (state) {
        return state.allCards;
    },

    getSelectedCards (state) {
        return state.selectedCards;
    },

    getCardsCreated (state) {
        return state.cardsCreated;
    },

    getCardCounterLoading (state) {
        return state.cardCounterLoading;
    },

    getCardLoading (state) {
        return state.cardLoading;
    },

    // ******* \\
    // Battles \\
    // ******* \\

    getBattle (state) {
        return state.battle;
    },

    getBattles (state) {
        let battles = state.battles;
        return battles.sort((a, b) => a.isComplete - b.isComplete );
    },

    getFilteredBattles (state) {
        return state.filteredBattles.sort((a, b) => a.isComplete - b.isComplete );
    },

    getBattleFilters (state) {
        return state.battleFilters;
    },

    getBattleResults (state) {
        return state.battleResults;
    },

    getBattleLoading (state) {
        return state.battleLoading;
    },

    getOpenBattleIds (state) {
        return state.openBattleIds;
    },

    // ********
    // Auctions

    getAuctions (state) {
        let auctions = state.auctions;
        return auctions.sort((a, b) => a.isComplete - b.isComplete );
    },

    getAuctionLoading (state) {
        return state.auctionLoading;
    },

    // **************
    // User interface

    getModalType (state) {
        return state.modalType;
    },

    getLoading (state) {
        return state.loading;
    },

    getHasExtension (state) {
        return state.hasExtension;
    },

    getPendingTransaction (state) {
        return state.pendingTransaction;
    },

    getHasError (state) {
        return state.hasError;
    },

    getLocale (state) {
        return state.locale;
    },

    // *****
    // Users

    getUser (state) {
        return state.user;
    },

    getUsers (state) {
        // Sort by winCount then winPercent then lossCount (puts 0 wins / 0 losses last)
        return state.users.sort(
            function (a, b) {
                let win1 = b.winCount;
                let win2 = a.winCount;

                let pct1 = b.winPercentage;
                let pct2 = a.winPercentage;

                let loss1 = b.lossCount;
                let loss2 = a.lossCount;

                if (win1 < win2) return -1;
                if (win1 > win2) return 1;
                if (pct1 < pct2) return -1;
                if (pct1 > pct2) return 1;
                if (loss1 < loss2) return -1;
                if (loss1 > loss2) return 1;
                return 0;
            }
        );
    },

    getUserLoading (state) {
        return state.userLoading;
    }

}



// WEBPACK FOOTER //
// ./src/store/getters.js